import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UsageDetailsModal = ({ entry, onClose }) => {
  if (!entry) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div>
            <h2 className="text-2xl font-bold text-foreground mb-1">
              Usage Details: "{entry?.word}"
            </h2>
            <p className="text-sm text-muted-foreground">
              Total occurrences: {entry?.totalUsageCount}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6">
          {entry?.playUsage && entry?.playUsage?.length > 0 ? (
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-foreground mb-4">
                Appearances by Play
              </h3>
              {entry?.playUsage?.map((play, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between p-4 bg-secondary/5 border border-border rounded-lg hover:bg-secondary/10 transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                      <Icon name="BookOpen" size={20} className="text-primary" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-foreground">
                        {play?.playTitle}
                      </h4>
                      <p className="text-sm text-muted-foreground">
                        {play?.count} {play?.count === 1 ? 'occurrence' : 'occurrences'}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="px-4 py-2 bg-accent/10 text-accent font-bold text-lg rounded-md">
                      {play?.count}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <Icon name="AlertCircle" size={48} className="text-muted-foreground mx-auto mb-4" />
              <p className="text-muted-foreground">
                This word has not been assigned to any lines yet.
              </p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-border">
          <Button variant="outline" onClick={onClose} className="w-full">
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UsageDetailsModal;
